module.exports = __webpack_public_path__ + "img/fortuna.ab4343f5.jpg";